import React, { useContext, useEffect, useState } from 'react'
import { QuizContext } from '@health-zelas/quiz'

import { TValidator } from '../types'
import { ValidatorDefaultValue } from '../constants'

import { FieldError } from '@packages/components'

import * as S from './Select.styles'

type SelectProps = {
  validator?: TValidator
} & React.ComponentProps<typeof S.Wrapper>

export const Select = ({
  name = '',
  validator = ValidatorDefaultValue,
  ...props
}: SelectProps) => {
  const [isValid, setIsValid] = useState(true)

  const { getFieldByName, validateField } = useContext(QuizContext)

  const fieldValue = getFieldByName(name) || ''

  useEffect(() => {
    setIsValid(validateField(name, validator))
  }, [fieldValue, name, validateField, validator])

  return (
    <div>
      <S.Wrapper {...props} name={name} />

      {!isValid && <FieldError msg={validator.msg(fieldValue)} />}
    </div>
  )
}
